<template>
    <div class="copyable-text">
        <div class="d-flex align-items-center">
            <span ref="text">{{text}}</span>
            <button title="Copy text" @click="copyText"><i class="gf gf-copy"></i></button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CopyableText",
        props: {
            text: String
        },
        methods: {
            copyText() {
                const span = this.$refs.text;
                let range = document.createRange();
                range.setStart(span, 0);
                range.setEnd(span, 1);
                let selection = document.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                document.execCommand('copy')
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/variables";

    .copyable-text {
        display: inline-block;

        button {
            border: none;
            background-color: transparent;
            padding: 0;
            outline: none;
            margin-left: 0.25rem;
            font-size: 0.86em;

            &:hover {
                border: none;
                color: $primary-blue;
            }

            &:focus {
                box-shadow: none;
            }
        }
    }
</style>
